import React, { Fragment, useEffect, useState } from "react";
import NavBarButton from "../NavBarButton";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow_left.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ProgramIcon } from "../../assets/icons/program.svg";
import { ReactComponent as ActionIcon } from "../../assets/icons/block.svg";
import { ReactComponent as ConfigIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as DatasetIcon } from "../../assets/icons/folder.svg";
import { ReactComponent as ModelIcon } from "../../assets/icons/hub.svg";
import { ReactComponent as WorkerIcon } from "../../assets/icons/worker.svg";

type Props = {
  onClick: any;
  navbarPath: string;
  navbarName: string;
  navbarIcon: any;
  navbarContainerClassName?: string;
  navbarIconClassName?: string;
  navbarLabelClassName?: string;
  icon?: any;
  dropDown: boolean;
  subcategories?: any;
};

const MobileMenuItem = (props: Props) => {
  const [dropState, setDropState] = useState(false);
  const [subcategories, setSubcategories] = useState(props.subcategories);
  const [animation, setAnimation] = useState(false);

  const handleIcon = (icon) => {
    switch (icon) {
      case "Program":
        return <ProgramIcon />;
      case "Action":
        return <ActionIcon />;
      case "Config":
        return <ConfigIcon />;
      case "Dataset":
        return <DatasetIcon />;
      case "Model":
        return <ModelIcon />;
      case "Worker":
        return <WorkerIcon />;
    }
  };

  const handleDropDownIcon = () => {
    setDropState(!dropState);
  };

  console.log(subcategories);
  return (
    <Fragment>
      <div className="mobile-menu-body-item">
        <div className="item-icon-name" onClick={props.onClick}>
          <NavBarButton
            path={props.navbarPath}
            name={props.navbarName}
            icon={props.navbarIcon}
            classNameContainer={`mobile-menu-row ${props.navbarContainerClassName}`}
            classNameIcon={`mobile-menu-icon ${props.navbarIconClassName}`}
            classNameLabel={
              props.navbarLabelClassName && props.navbarLabelClassName
            }
          />
        </div>
        {props.dropDown && (
          <div className="item-dropdown-icon" onClick={handleDropDownIcon}>
            {dropState ? (
              <ArrowDown />
            ) : (
              <ArrowLeft className={animation && "spin"} />
            )}
          </div>
        )}
      </div>
      <div className="item-dropdown-content" onClick={props.onClick}>
        {dropState &&
          subcategories &&
          subcategories.map((dropdownItem) => (
            <NavBarButton
              path={dropdownItem.to}
              name={dropdownItem.name}
              icon={handleIcon(dropdownItem.icon)}
              classNameContainer="dropdown-item"
            />
          ))}
      </div>
    </Fragment>
  );
};

export default MobileMenuItem;
